import React from 'react';
import { motion } from 'framer-motion';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      number: 1,
      title: 'Selecciona un área',
      description: 'Indica qué aspecto de tu bienestar emocional te gustaría evaluar.'
    },
    {
      number: 2,
      title: 'Responde brevemente',
      description: 'Contesta unas simples preguntas sobre cómo te has sentido recientemente.'
    },
    {
      number: 3,
      title: 'Recibe orientación',
      description: 'Obtén una evaluación de tu nivel actual y recomendaciones personalizadas.'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1
    }
  };

  return (
    <section className="how-it-works">
      <h2>¿Cómo funciona?</h2>
      
      <motion.div 
        className="steps-container"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {steps.map((step) => (
          <motion.div 
            key={step.number}
            className="step"
            variants={itemVariants}
          >
            <div className="step-number">{step.number}</div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default HowItWorks;
